import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import RegisteRoute from './Register.routes';
import UserRoute from './User.routes';
import HomeRoute from './Home.routes';
import { PrivateRoute } from './Private.routes';
import AblContextProvider from '../Context';
import WelcomePage from '../Pages/Welcome';
function Routes() {
    return(
        <>
        <AblContextProvider>
          <BrowserRouter>
            <Switch>
              <Route path="/" exact component={WelcomePage} />
              <Route path="/register" exact component={RegisteRoute}/>
              <Route path="/login" exact component={UserRoute} />
              <PrivateRoute path="/home" exact component={HomeRoute} />
              <Redirect to="/"/>
            </Switch>
          </BrowserRouter>
        </AblContextProvider>
        </>
    )
}

export default Routes;
